import { render, staticRenderFns } from "./StatisticsBox.vue?vue&type=template&id=7ab2d430"
import script from "./StatisticsBox.vue?vue&type=script&lang=js"
export * from "./StatisticsBox.vue?vue&type=script&lang=js"
import style0 from "../assets/StatisticsBox.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports